import { TThunkAction } from '../../types/redux';
import { setNextStep } from '../../actions/newReview';
import { addReview } from '../../services/reviews/addReview';
import { setLoading } from './loadingActionTypes';
import { setLoadingError } from './loadingErrorActionTypes';
import { mapFlowToTripStatus } from '../../utils/newReview/mapFlowToTripStatus';
import { mapFormRatingToRating } from '../../utils/newReview/mapFormRatingToRatingSchema';
import { setPublishedId } from './publicshedActionTypes';

export function addReviewActions(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    try {
      const state = getState();
      const { httpApi } = context;
      const { objectInfo, newReview } = state;

      dispatch(setLoadingError(false));
      dispatch(setLoading(true));

      const reviewId = await addReview({
        httpApi,
        parameters: {
          offerId: objectInfo.objectId,
          tripId: newReview.meta.tripId,
          tripStatus: mapFlowToTripStatus(newReview.meta.flow),
          rating: mapFormRatingToRating(newReview.data),
          positiveReview: newReview.data.pros,
          negativeReview: newReview.data.cons,
        },
      });

      dispatch(setLoading(false));
      dispatch(setNextStep());
      dispatch(setPublishedId(reviewId));
    } catch (e) {
      dispatch(setLoading(false));
      dispatch(setLoadingError(true));
    }
  };
}
